import { useState } from 'react';
import type { BankCode } from '../api/paymentBank.js';

/**
 * 은행 선택 드롭다운. 은행 로고를 보여준다 — 원본 bank_modify.php 의
 * BankSelector Vue 컴포넌트를 그대로 옮긴 것.
 */
export function BankSelect({
  value,
  options,
  onChange,
}: {
  value: string;
  options: BankCode[];
  onChange: (code: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const selected = options.find((b) => b.code === value);

  // 옵션을 클릭해도 드롭다운이 안 닫히던 버그: Field 가 기본으로 children 을
  // <label> 로 감싸는데, <button> 은 라벨이 붙는(labelable) 엘리먼트라 그 label
  // 안에서 일어나는 아무 클릭이나 (옵션 div를 눌러도) 브라우저가 트리거 버튼에
  // 클릭을 한 번 더 forwarding 한다 — 이건 네이티브 버블링 도중에 일어나서
  // React 핸들러 안의 stopPropagation() 으론 못 막는다. 그래서 이 필드는 호출부
  // (BankPage.tsx) 에서 <Field as="div"> 로 label 자체를 안 쓴다. 아래
  // stopPropagation() 들은 그와 별개로 모달 오버레이(바깥 클릭 시 모달 닫힘)로
  // 새는 걸 막는 방어용이다.
  return (
    <div className="bank-select">
      {open && (
        <div
          className="bank-select__overlay"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(false);
          }}
        />
      )}
      <button
        type="button"
        className={open ? 'bank-select__trigger bank-select__trigger--open' : 'bank-select__trigger'}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        {selected ? (
          <span className="bank-select__value">
            {selected.imageurl && <img className="bank-select__logo" src={selected.imageurl} alt="" />}
            <span>{selected.bankname}</span>
          </span>
        ) : (
          <span className="bank-select__placeholder">은행 선택</span>
        )}
        <span className="bank-select__caret">▼</span>
      </button>
      {open && (
        <div className="bank-select__list">
          {options.map((b) => (
            <div
              key={b.code}
              className={b.code === value ? 'bank-select__option bank-select__option--active' : 'bank-select__option'}
              onClick={(e) => {
                e.stopPropagation();
                onChange(b.code);
                setOpen(false);
              }}
            >
              {b.imageurl && <img className="bank-select__logo" src={b.imageurl} alt="" />}
              <span>{b.bankname}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
